export const createAdapter = adapterInterface => oldObject => {
  if (!oldObject) return
  const oldKeys = Object.keys(oldObject)
  return oldKeys.reduce((acc, oldKey) => {
    if (adapterInterface[oldKey]) {
      return { ...acc, [adapterInterface[oldKey]]: oldObject[oldKey] }
    } else return { ...acc, [oldKey]: oldObject[oldKey] }
  }, {})
}
